import { Button } from "components/elements/Button";

export const NothingFound = ({ onClearFilters }: { onClearFilters?: () => void }) => {
    return (
        <div className="h-full justify-center">
            <div className="flex flex-col items-center justify-center gap-4 py-4">
                <div>Nothing was found</div>
                {onClearFilters && (
                    <Button
                        size="smaller"
                        variant="primary"
                        className="m-auto"
                        onClick={onClearFilters}
                    >
                        Clear Filters
                    </Button>
                )}
            </div>
        </div>
    );
};
